import React, { useState } from "react";

const Accordion = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="w-full">
      {data.map((item, index) => (
        <div key={index} className={`shadow-sm rounded-md mb-4 ${activeIndex === index ? "border-b-2 border-[#059669]" : ""}`}>
          {/* Accordion Header */}
          <div
            className="bg-white p-3 cursor-pointer flex gap-4 items-center"
            onClick={() => toggleAccordion(index)}
          >
            <p className="p-2 bg-[#F3FFF9] text-[#059669] px-2 bg-opacity-50 inline-block rounded-full">{index+1}</p>
            <p className="text-gray-800 text-[10px] lg:text-base inline-block  font-medium">{item.title}</p>

            {/* Animated Arrow */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="11"
              className={`ml-auto transition-transform duration-300 ${
                activeIndex === index ? "rotate-180" : "rotate-0"
              }`}
              viewBox="0 0 19 11"
              fill="none"
            >
              <path
                d="M9.25 10.25C8.89844 10.25 8.58594 10.1328 8.35156 9.89844L0.851562 2.39844C0.34375 1.92969 0.34375 1.10938 0.851562 0.640625C1.32031 0.132812 2.14062 0.132812 2.60938 0.640625L9.25 7.24219L15.8516 0.640625C16.3203 0.132812 17.1406 0.132812 17.6094 0.640625C18.1172 1.10938 18.1172 1.92969 17.6094 2.39844L10.1094 9.89844C9.875 10.1328 9.5625 10.25 9.25 10.25Z"
                fill="#181F47"
              />
            </svg>
          </div>

          {/* Accordion Content */}
          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${
              activeIndex === index ? "max-h-40 p-3" : "max-h-0"
            }`}
          >
            <p className="text-gray-600 text-[10px] lg:text-base ">{item.content}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
